module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Koke nesilice icon (1).835cd1d3.svg";